import { jsxs, jsx } from 'react/jsx-runtime';

const FLEX_GRADIENT_SVG_ID = {
  tropical: "flex-gradient-svg-tropical",
  magic: "flex-gradient-svg-magic",
  flame: "flex-gradient-svg-flame",
  mango: "flex-gradient-svg-mango"
};
const STOP_COLOR_SET = {
  tropical: {
    start: "#04cc00",
    end: "#11c2cd"
  },
  magic: {
    start: "#a348ff",
    end: "#6066FF"
  },
  flame: {
    start: "#f96919",
    end: "#FB60BD"
  },
  mango: {
    start: "#fa9e00",
    end: "#ff8e26"
  }
};
function FlexLinearGradient({
  id,
  type
}) {
  const { start, end } = STOP_COLOR_SET[type];
  return /* @__PURE__ */ jsxs("linearGradient", { id: getID(type, id), gradientTransform: "rotate(96.77)", children: [
    /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: start }),
    /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: end })
  ] });
}
function getID(gradient, suffix) {
  return `${FLEX_GRADIENT_SVG_ID[gradient]}-${suffix}`;
}

export { FLEX_GRADIENT_SVG_ID, FlexLinearGradient as default, getID };
//# sourceMappingURL=FlexLinearGradient.mjs.map
